<template>
  <div>
    <md-dialog
      v-model="agreementVisible"
      :title="$t('activation_time_limit')"
      :closable="false"
      :btns="slotDialog.btns"
    >
      <div>
        {{ $t('late_message') }}
      </div>
    </md-dialog>
  </div>
</template>

<script>
import { Dialog } from 'mand-mobile'
import { getStep } from '@/api/activateLowLevelStep'
import { confirmStep } from '@/constants'
export default {
  name: 'AgreementDialog',
  components: {
    [Dialog.name]: Dialog
  },
  data () {
    return {
      confirmStep,
      slotDialog: {
        btns: [
          {
            text: this.$t('cancel'),
            handler: this.onBasicCancel
          },
          {
            text: this.$t('agree_btn'),
            handler: this.onBasicConfirm
          }
        ]
      }
    }
  },
  computed: {
    agreementVisible: {
      get () {
        return this.$store.state.agreementVisible
      },
      set () {}
    }
  },
  methods: {
    async knowGetStep () {
      // 1 是从第一步 2 是低级面部识别
      const { code } = await getStep()
      if (code === 1) this.$router.push({ name: 'ActivateLowLevelStep1' })
      if (code === 2) this.$router.push({ name: 'ActivateLowLevelStep3' })
    },
    onBasicConfirm (code) {
      this.$store.commit('change_agreementVisible', false)
      // 添加弹窗不让激活 提示
      // Dialog.alert({
      //   content: this.$t('wallet_active_stop'),
      //   confirmText: this.$t('i_know') // 我知道了
      // })
      // 实名到一半，再次跳转实名，跳过已经填入信息的页面。
      this.knowGetStep() // 已经完成2000人认证暂时关闭实名认证
    },
    onBasicCancel () {
      this.$store.commit('change_agreementVisible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .md-dialog-body {
  text-align: left;
  line-height: 48px;
}

::v-deep .md-dialog-title {
  text-align: left;
}

::v-deep .md-dialog-content {
  border-radius: 32px;
}
</style>
